import React from 'react';
import { Store } from 'react-notifications-component';
import { NumericFormat } from 'react-number-format';
//@ts-ignore
import Numeral from 'react-numeral';

import { ethers } from 'ethers';
import { useAccount } from 'wagmi';

import { useGlobalContext } from '../AppContext';
import erc20ABI from '../sdk/erc20/abi.json';

export const getMetamaskConnected = () => localStorage.getItem('walletConnected') === 'true';

export const setMetamaskConnected = (connected: boolean) =>
  localStorage.setItem('walletConnected', connected.toString());

export const timeConverter = (UNIX_timestamp: number) => {
  const a = new Date(UNIX_timestamp * 1000);
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const year = a.getFullYear();
  const month = months[a.getMonth()];
  const date = a.getDate();
  const hour = a.getHours();
  const min = a.getMinutes();
  const sec = a.getSeconds();
  const time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec;

  return time;
};

export const parsePercentage = (amount: any): any => {
  return <NumericFormat displayType="text" value={amount} suffix="%" decimalScale={2} />;
};

export const parseNumber = (amount: any): any => {
  if (amount === '?') return amount;
  return <NumericFormat displayType="text" value={amount} decimalScale={0} />;
};

export const parseAmount = (amount: any, raw?: false, decimals?: number): any => {
  if (raw) {
    return parseFloat(amount);
  } else {
    if (amount.toString().length > 9) {
      return <Numeral value={amount} format={'0.00a'} />;
    }
    return (
      <NumericFormat
        displayType="text"
        value={amount}
        decimalScale={decimals || getPrecision(amount)}
        thousandSeparator=","
      />
    );
  }
};

const getPrecision = (num: any): number => {
  return 5;
  const number = parseFloat(num);
  let numAsStr = number.toFixed(18); //number can be presented in exponential format, avoid it
  numAsStr = numAsStr.replace(/0+$/g, '');
  const precision = String(numAsStr).replace('.', '').length - number.toFixed().length;

  return precision;
};
export const parseMoney = (amount: any, raw?: false | true, decimals?: number): any => {
  if (raw) {
    return parseFloat(amount);
  } else {
    return (
      <NumericFormat
        displayType="text"
        decimalScale={decimals ? decimals : getPrecision(amount)}
        value={amount}
        prefix={'$'}
        thousandSeparator=","
      />
    );
  }
};

export const notify = (title: any, message?: string) => {
  Store.addNotification({
    title: title,
    message: message || '',
    type: 'info',
    insert: 'top',
    container: 'top-right',
    animationIn: ['animate__animated', 'animate__fadeIn'],
    dismiss: {
      duration: 4000,
      onScreen: false,
    },
  });
};

export const fetchTokenDetails = async (tokenContract: string, network: string) => {
  let provider = null;
  if (network === 'Ethereum') {
    provider = new ethers.providers.JsonRpcProvider('https://rpc.ankr.com/eth');
  } else if (network === 'BSC') {
    provider = new ethers.providers.JsonRpcProvider('https://bsc.nodereal.io');
  } else if (network === 'Polygon') {
    provider = new ethers.providers.JsonRpcProvider('https://rpc.ankr.com/polygon');
  } else if (network === 'Avalanche') {
    provider = new ethers.providers.JsonRpcProvider('https://rpc.ankr.com/avalanche');
  } else if (network === 'Moonbeam') {
    provider = new ethers.providers.JsonRpcProvider('https://rpc.api.moonbeam.network');
  } else if (network === 'Moonriver') {
    provider = new ethers.providers.JsonRpcProvider('https://moonriver.public.blastapi.io');
  } else if (network === 'Mantle') {
    provider = new ethers.providers.JsonRpcProvider('https://rpc.testnet.mantle.xyz');
  }

  if (provider) {
    const contract = new ethers.Contract(tokenContract, erc20ABI, provider);

    const result: { name: string; symbol: string; totalSupply: string } = {
      name: '',
      symbol: '',
      totalSupply: '',
    };

    // Get data from new SDK
    try {
      result.name = await contract.name.call();
      result.symbol = await contract.symbol.call();
      result.totalSupply = await contract.totalSupply.call();

      return result;
    } catch (e: any) {
      notify('Cannot retrieve data from contract. Please check contract address and network.');
    }
  }
  return {};
};

export const calculateColumnWidth = (table: string, type: string) => {
  const { isMobile, wallets } = useGlobalContext();
  const { address: account } = useAccount();

  const data: any = {
    dashboard: {
      icon: {
        desktop: wallets && wallets.length > 1 ? '40px' : '40px',
        mobile: wallets && wallets.length > 1 ? '40px' : '40px',
      },
      wallet: {
        desktop: wallets && wallets.length > 1 ? '120px' : '10px',
        mobile: wallets && wallets.length > 1 ? '120px' : '20px',
      },
      nativeBalance: {
        desktop: wallets && wallets.length > 1 ? '80px' : '100px',
        mobile: wallets && wallets.length > 1 ? '80px' : '100px',
      },
      portfolio: {
        desktop: wallets && wallets.length > 1 ? '80px' : '100px',
        mobile: wallets && wallets.length > 1 ? '80px' : '90px',
      },
      '24h': {
        desktop: wallets && wallets.length > 1 ? '60px' : '70px',
        mobile: wallets && wallets.length > 1 ? '60px' : '60px',
      },
      tokens: {
        desktop: wallets && wallets.length > 1 ? '50px' : '70px',
        mobile: wallets && wallets.length > 1 ? '50px' : '60px',
      },
      nft: {
        desktop: wallets && wallets.length > 1 ? '50px' : '60px',
        mobile: wallets && wallets.length > 1 ? '50px' : '50px',
      },
      ens: {
        desktop: wallets && wallets.length > 1 ? '50px' : '50px',
        mobile: wallets && wallets.length > 1 ? '50px' : '50px',
      },
      fee: {
        desktop: wallets && wallets.length > 1 ? '80px' : '90px',
        mobile: wallets && wallets.length > 1 ? '80px' : '80px',
      },
      age: {
        desktop: wallets && wallets.length > 1 ? '110px' : '90px',
        mobile: wallets && wallets.length > 1 ? '110px' : '130px',
      },
    },

    myPortfolio: {
      icon: {
        desktop: account ? '40px' : '40px',
        mobile: account ? '40px' : '40px',
      },
      token: {
        desktop: account ? '180px' : '180px',
        mobile: account ? '180px' : '180px',
      },
      category: {
        desktop: account ? '90px' : '90px',
        mobile: account ? '90px' : '90px',
      },
      ratio: {
        desktop: account ? '50px' : '50px',
        mobile: account ? '50px' : '50px',
      },
      amount: {
        desktop: account ? '90px' : '90px',
        mobile: account ? '90px' : '90px',
      },
      balance: {
        desktop: account ? '110px' : '110px',
        mobile: account ? '110px' : '110px',
      },
      price: {
        desktop: account ? '80px' : '80px',
        mobile: account ? '80px' : '80px',
      },
      '24h': {
        desktop: account ? '60px' : '60px',
        mobile: account ? '60px' : '60px',
      },
      holders: {
        desktop: account ? '80px' : '80px',
        mobile: account ? '80px' : '80px',
      },
      marketcap: {
        desktop: account ? '100px' : '100px',
        mobile: account ? '100px' : '100px',
      },
      graph: {
        desktop: account ? '120px' : '120px',
        mobile: account ? '120px' : '120px',
      },
      action: {
        desktop: account ? '100px' : '100px',
        mobile: account ? '100px' : '100px',
      },
    },

    buyAndSell: {
      token: {
        desktop: account ? '500px' : '500px',
        mobile: account ? '500px' : '500px',
      },
      price: {
        desktop: account ? '100px' : '100px',
        mobile: account ? '100px' : '100px',
      },
      '24h': {
        desktop: account ? '100px' : '100px',
        mobile: account ? '100px' : '100px',
      },
      holders: {
        desktop: account ? '100px' : '100px',
        mobile: account ? '100px' : '100px',
      },
      marketcap: {
        desktop: account ? '100px' : '100px',
        mobile: account ? '100px' : '100px',
      },
      action: {
        desktop: account ? '100px' : '100px',
        mobile: account ? '100px' : '100px',
      },
    },

    vestingCalendar: {
      name: {
        desktop: account ? '120px' : '120px',
        mobile: account ? '120px' : '120px',
      },
      symbol: {
        desktop: account ? '80px' : '100px',
        mobile: account ? '100px' : '100px',
      },
      totalSupply: {
        desktop: account ? '100px' : '100px',
        mobile: account ? '100px' : '100px',
      },
      initialMarketcap: {
        desktop: account ? '140px' : '100px',
        mobile: account ? '100px' : '100px',
      },
      saleType: {
        desktop: account ? '100px' : '100px',
        mobile: account ? '100px' : '100px',
      },
      distribution: {
        desktop: account ? '120px' : '100px',
        mobile: account ? '100px' : '100px',
      },
      price: {
        desktop: account ? '100px' : '100px',
        mobile: account ? '100px' : '100px',
      },
      action: {
        desktop: account ? '100px' : '100px',
        mobile: account ? '100px' : '100px',
      },
    },

    lp: {
      network: {
        desktop: account ? '110px' : '110px',
        mobile: account ? '110px' : '110px',
      },
      pair: {
        desktop: account ? '200px' : '200px',
        mobile: account ? '200px' : '200px',
      },
      liquidity: {
        desktop: account ? '80px' : '100px',
        mobile: account ? '100px' : '100px',
      },
      token: {
        desktop: account ? '100px' : '100px',
        mobile: account ? '100px' : '100px',
      },
      providerCount: {
        desktop: account ? '140px' : '140px',
        mobile: account ? '140px' : '140px',
      },
      action: {
        desktop: account ? '120px' : '120px',
        mobile: account ? '120px' : '120px',
      },
    },
  };

  return data[table][type][isMobile ? 'mobile' : 'desktop'];
};
